export default "__VITE_ASSET__DI5FVcsV__"